import { useRouter } from 'next/router';
import { isWebview } from '@helpers/routing';

const useIsWebview = () => {
  const { query } = useRouter();

  return isWebview(query);
};

export default useIsWebview;
